const keysToPrevent = [
  'KeyB', // native bold action
  'KeyI', // native italic action
  'KeyU', // native underline action
  'KeyK', // native browser action
  'KeyZ', // native contenteditable history
  'KeyS', // native browser page saving
];

const preventNativeContentEditing = (event) => {
  const { ctrlKey, code, metaKey } = event;

  if (!keysToPrevent.includes(code)) return;

  if (metaKey || ctrlKey) {
    event.preventDefault();
  }
};

export default preventNativeContentEditing;
